import { lazy } from 'react';
import { type RouteDefinition } from '@router';

// layouts container
const Layouts = {
	App: lazy(() => import('app/layouts/app/App.layout')),
};

// pages container
const Pages = {
	Vigilancia: lazy(() => import('app/pages/vigilancia/main.vigilancia')),
};

/**
 * Routes definition.
 *
 * Here you must define your app routes
 * per namespace.
 * A namespace helps you to organize your
 * routes, for example 'app', 'public',
 * 'private', etc.
 *
 * This routes should be used in createRouter
 * function from @router module.
 */
export const routes: Record<string, RouteDefinition[]> = {
	app: [
		{
			path: '/',
			render: {
				layout: Layouts.App,
				children: [
					{
						title: 'Vigilancia',
						path: 'resultados',
						render: {
							child: Pages.Vigilancia,
						},
					},
				],
			},
			payload: {
				profile: 'Employee',
				header: {
					title: 'HEADER BASE',
				},
				footer: {
					text: 'FOOTER BASE',
				},
			},
		},
	],
};
